import { TEAM_PARAMETER_LEXICON_MAP } from "../../../config/parametrs/teamParameterLexiconMapping";

const MATCH_EVENT_TITLE_LEXICON_MAP = {
  goal: TEAM_PARAMETER_LEXICON_MAP.goal,
  "yellow card": TEAM_PARAMETER_LEXICON_MAP["yellow card"],
  "red card": TEAM_PARAMETER_LEXICON_MAP["red card"],
};

const MATCH_EVENT_TITLE_TRANSLATION_KEY_MAP = {
  "1st half": "matchEvents.firstHalf",
  "2nd half": "matchEvents.secondHalf",
  "half time": "matchEvents.halfTime",
  substitution: "matchEvents.substitution",
  injury: "matchEvents.injury",
  off: "matchEvents.off",
  on: "matchEvents.on",
  event: "matchEvents.event",
};

const normalizeMatchEventTitle = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value).trim().toLowerCase();
};

const getActionTitle = (actionInput) => {
  if (typeof actionInput === "string") {
    return actionInput;
  }

  if (!actionInput || typeof actionInput !== "object") {
    return "";
  }

  return actionInput.title || actionInput.name || "";
};

const getActionLexiconId = (actionInput) => {
  if (!actionInput || typeof actionInput !== "object") {
    return null;
  }

  return actionInput.lexic_id ?? actionInput.lexic ?? actionInput.lexc ?? null;
};

const translateStaticMatchEventLabel = (rawTitle, t) => {
  const normalizedTitle = normalizeMatchEventTitle(rawTitle);
  const translationKey = MATCH_EVENT_TITLE_TRANSLATION_KEY_MAP[normalizedTitle];

  if (!translationKey) {
    return "";
  }

  return t?.(translationKey) || rawTitle;
};

export const resolveMatchEventLabel = (actionInput, { l, t } = {}) => {
  const rawTitle = getActionTitle(actionInput);
  const directLexiconId = getActionLexiconId(actionInput);

  if (directLexiconId) {
    const translatedByActionLexicon = l?.(directLexiconId);
    if (translatedByActionLexicon) {
      return translatedByActionLexicon;
    }
  }

  const mappedLexiconId =
    MATCH_EVENT_TITLE_LEXICON_MAP[normalizeMatchEventTitle(rawTitle)];
  if (mappedLexiconId) {
    const translatedByMappedLexicon = l?.(mappedLexiconId);
    if (translatedByMappedLexicon) {
      return translatedByMappedLexicon;
    }
  }

  const translatedStaticLabel = translateStaticMatchEventLabel(rawTitle, t);
  if (translatedStaticLabel) {
    return translatedStaticLabel;
  }

  return rawTitle || t?.("matchEvents.event") || "Event";
};

export const isSubstitutionMatchEvent = (marker) => {
  return normalizeMatchEventTitle(marker?.action?.title || marker?.action) === "substitution";
};

export const buildMatchEventDescription = (marker, { l, t } = {}) => {
  const eventLabel = resolveMatchEventLabel(marker?.action, { l, t });

  if (isSubstitutionMatchEvent(marker)) {
    const offLabel = translateStaticMatchEventLabel("Off", t) || "Off";
    const onLabel = translateStaticMatchEventLabel("On", t) || "On";
    const creatorText = marker?.creator?.surname
      ? `${marker.creator.surname} ${offLabel}`
      : "";
    const recipientText = marker?.recipient?.surname
      ? `${marker.recipient.surname} ${onLabel}`
      : "";

    return [creatorText, recipientText].filter(Boolean).join(", ");
  }

  return marker?.creator?.surname
    ? `${eventLabel} ${marker.creator.surname}`
    : eventLabel;
};

export const buildMatchEventVideoTitle = (marker, { l, t } = {}) => {
  const eventLabel = resolveMatchEventLabel(marker?.action, { l, t });
  const creatorFullName = [marker?.creator?.name, marker?.creator?.surname]
    .filter(Boolean)
    .join(" ");

  return creatorFullName ? `${eventLabel} - ${creatorFullName}` : eventLabel;
};
